// extracted by mini-css-extract-plugin
module.exports = {"prtp_ads":"CoursePreview_prtp_ads__7E0jg","overflow":"CoursePreview_overflow__9eKkM","bg_ads":"CoursePreview_bg_ads__BJm0B"};